import React, {useContext, useEffect, useState} from "react";
import "./Liker.css";
import {LikesContext} from "../contexts/LikesContext";
import { ratePost } from "../services/posts";
import {UserContext} from "../contexts/UserContext";
import {useAuthenticatedAction} from "../hooks/useAuthenticatedAction";
import { HeartIcon } from '@heroicons/react/24/solid';

interface LikerProps {
    count: number,
    postID: number
}

const Liker:React.FC<LikerProps> = ( {count, postID} ) => {
    const [localCount, setLocalCount] = useState(count);
    const {currentUser} = useContext(UserContext);
    const {likes, setLikes} = useContext(LikesContext);
    const [liked, setLiked] = useState(false);
    const { execute: submitRating, loading: rateOnGoing } = useAuthenticatedAction();

    const toggleLike = async () => {
        if(currentUser === null || rateOnGoing) return;

        const response = await submitRating(ratePost, postID);
        if (response) {
            setLocalCount(response.new_ratings_score);

            let newLikes : number[];
            if(!liked){
                newLikes = [
                    postID,
                    ...likes
                ];
            }else{
                newLikes = likes.filter( p => p !== postID);
            }
            if(newLikes.length > 100){
                newLikes.pop();
            }
            setLikes(newLikes);
            localStorage.setItem("likes", JSON.stringify(newLikes));
        }
    }

    useEffect(() => {
        setLiked(likes && ( -1 !== likes.indexOf(postID) ));
    }, [likes, postID]);

    return (
        <button type={"button"} className={"Liker " + (liked ? "liked " : " ") + (rateOnGoing ? "busy " : " ")} onClick={() => toggleLike()}>
            <span className={"count"}>{localCount}</span> <HeartIcon className="heart" />
        </button>
    )
}

export default Liker;